import { useCallback, useEffect, useMemo, useState } from 'react'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'

// AUTH TOKEN START
import jwt_decode from 'jwt-decode'
import { ls } from 'utils'
import { LSKEY_TOKEN } from 'constants/app'
// AUTH TOKEN END

import {
  CreateMemberFormTypes,
  CreateMemberFormSubmitValuesTypes,
  CreateMemberFormSubmitActionsTypes,
} from 'types/member'
import useMemberStore from 'store/member'

import { isQSRHClient } from 'setups/controller'
import { projectClient } from 'constants/project'

const CREATEMEMBERTXINITVAL: CreateMemberFormTypes = {
  cardNumber: null,
  cardPin: null,
  password: null,
  titleId: null,
  firstName: null,
  lastName: null,
  rankingId: null,
  mobile: null,
  email: null,
  genderId: null,
  birthDate: null,
  postalAddress: {
    address1: null,
    address2: null,
    address3: null,
    address4: null,
    suburb: null,
    city: null,
    state: null,
    postcode: null,
    countryId: null,
  },
  physicalAddress: {
    address1: null,
    address2: null,
    address3: null,
    address4: null,
    suburb: null,
    city: null,
    state: null,
    postcode: null,
    countryId: null,
  },
  enrollmentTraderId: null,
  mailingPreferenceId: null,
  custom1: null,
  custom2: null,
  custom3: null,
  website: null,
  comments: null,
  phone1: null,
  phone2: null,
  gdpr: {
    flOffer: 0,
    flCompet: 0,
    flNews: 0,
    flEmail: 0,
    flSms: 0,
    flApp: 0,
    flTnc: 0,
    flPrivacy: 0,
    tncVersion: null,
    privacyVersion: null,
    consentDate: null,
    reasonId: null,
  },
}

export const useCreateMember = (
  traderId: number,
  onCloseModal: () => void
): {
  isLoading: boolean
  initialValues: CreateMemberFormTypes
  handleSubmitCreateMember: (
    values: CreateMemberFormSubmitValuesTypes,
    actions: CreateMemberFormSubmitActionsTypes
  ) => void
  // handleClearPurchaseTx: () => void
} => {
  const navigate = useNavigate()
  // AUTH TOKEN START
  const authToken = ls.get(LSKEY_TOKEN)
  const decodeAuthToken: { username: string } = jwt_decode(String(authToken))
  // AUTH TOKEN END
  // MEMBER CREATE START
  const memberTraderIdNewlyCreated = useMemberStore(
    (state) => state.memberTraderIdNewlyCreated
  )
  const createMember = useMemberStore((state) => state.createMember)
  const memberCreateLoading = useMemberStore(
    (state) => state.memberCreateLoading
  )
  const memberCreateStatus = useMemberStore((state) => state.memberCreateStatus)
  // MEMBER CREATE END
  // MISC STATES START
  const [initialValues, initialValuesSet] = useState<CreateMemberFormTypes>({
    ...CREATEMEMBERTXINITVAL,
  })
  // MISC STATES END

  const isLoading = useMemo(() => {
    return memberCreateLoading ? true : false
  }, [memberCreateLoading])

  useEffect(() => {
    if (memberTraderIdNewlyCreated)
      navigate(`/member-profile/${memberTraderIdNewlyCreated}/dashboard`)
  }, [memberTraderIdNewlyCreated])

  const generateRandomPassword = (length = 12): string => {
    const chars =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*'
    let password = ''

    for (let i = 0; i < length; i++) {
      password += chars.charAt(Math.floor(Math.random() * chars.length))
    }

    return password
  }

  const handleSubmitCreateMember = useCallback(
    async (
      values: CreateMemberFormSubmitValuesTypes,
      actions: CreateMemberFormSubmitActionsTypes
    ) => {
      try {
        actions.setSubmitting(true)
        const payload = {
          ...values,
          password: isQSRHClient(projectClient)
            ? generateRandomPassword(12)
            : values.password,
        }
        const result = await createMember(payload)
        console.log({ result })
        toast.success(`Create Member successful.`)
        onCloseModal()
      } catch (error) {
        const message = JSON.parse(JSON.stringify(error))
        // if (message.outcomeUserMessage === 'This mobile number is already registered') {
        //   toast.error(`This mobile number is already registered`)
        // } else if (message.outcomeUserMessage === 'This email address is already registered') {
        //   toast.error(`This email address is already registered`)
        // } else {
        //   toast.error(`Member create error.`)
        // }
        toast.error(message.outcomeUserMessage)
        // modalClose()
      } finally {
        actions.setSubmitting(false)
      }
    },
    [createMember]
  )

  const handleClearPurchaseTx = useCallback(() => {
    initialValuesSet({ ...CREATEMEMBERTXINITVAL })
    toast.success('Filter successfully cleared.')
  }, [initialValuesSet])

  return {
    isLoading,
    initialValues,
    handleSubmitCreateMember,
  }
}
